import { triggerCharacter } from './trigger-character';
export const EMOJI_TYPEAHEAD = {
  name: 'emoji',
  matcher: triggerCharacter(':', {
    minLength: 2
  }),
  component: 'tools/typeaheads/emoji'
};